import React from 'react';
import TileComingSoon from "../../../../../components/customBreachBits/metrics/TileComingSoon";
import Tooltip from "@material-ui/core/Tooltip";
import Banner from "../../../../../assets/images/BreachRisk_Inquiries_Banner.svg";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
// import {useSelector} from "react-redux";

const Dashboard= (props) => {

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // const customer = customers ? customers[customerInView] : null;

    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
      <div className="animated fadeIn animation-duration-7">
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                  </div>
              </div>
              <div className={"col-4 align-self-center"}>
                  <h3>Lorem ipsum dolor <Tooltip title={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. In luctus dolor at pharetra tempor. Curabitur pretium ligula ligula, nec consequat ante vestibulum non. Sed vel imperdiet erat, et commodo libero."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In luctus dolor at pharetra tempor. Curabitur pretium ligula ligula, nec consequat ante vestibulum non. Sed vel imperdiet erat, et commodo libero.</p>

              </div>
          </div>
          <hr/>

          <div className="row">

              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
          </div>
          <div className="row">

              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <TileComingSoon/>
              </div>
          </div>
      </div>
        </div>
        // </MultiBoardWrapper>
    )
}
export default Dashboard;